import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IndustriepartnerHttpService } from 'src/app/core/services/industriepartner-http.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-industriepartner-neu',
  templateUrl: './industriepartner-neu.component.html',
  styleUrls: ['./industriepartner-neu.component.scss']
})
export class IndustriepartnerNeuComponent implements OnInit {

  public industriepartners = [];
  public filteredIndustriePartners = [];
  public search;
  public industriepartner = null;

  constructor(private industriepartnerService: IndustriepartnerHttpService, private snack: MatSnackBar, private router: Router) { }

  public loading = false;
  ngOnInit(): void {
    this.loading = true;
    this.industriepartnerService.getIndustriepartnerSmallList().subscribe(res => {
      this.loading = false;
      this.industriepartners = res as [];
      if(this.industriepartners.length > 20) {
        this.filteredIndustriePartners = this.industriepartners.slice(0, 20);
      } else {
        this.filteredIndustriePartners = res as [];
      }
    }, err => {
      console.log(err);
      this.loading = false;
    })
  }

  searching() {
    if(this.search.length == 0) {
      this.filteredIndustriePartners = this.industriepartners.slice(0, 20);
    }
    if(this.search.length < 2) {
      return;
    }
    this.filteredIndustriePartners = this.industriepartners.filter(i => {
      let anbieterNr = i.anbieterNr+'';
      return (anbieterNr.startsWith(this.search));
    });
  }

  display(i) {
    return i ? i.display : '';
  }

  public adding = false;
  add() {
    this.adding = true;
    this.industriepartnerService.addIndustriepartner(this.search.anbieterNr).subscribe(res => {
      this.adding = false;
      console.log(res);
      this.router.navigateByUrl('/industriepartner/'+this.search.anbieterNr);
    }, err => {
      this.adding = false;
      if(err.status == 409) {
        this.snack.open('Dieser Industriepartner wurde bereits als Kunde angelegt.', '', {panelClass: 'danger-snackbar'});
      }
      console.log(err);
    })
  }
}
